<template>
    <div class="wrap">

        <h1>{{t}}</h1>

        <div class="borad">
            <vue-seamless-scroll :data="newsList" :class-option="optionLeft" class="seamless-warp2">
                <ul class="item">
                    <li v-for="item in newsList" :key="item" v-text="item"></li>
                </ul>
            </vue-seamless-scroll>
            <vue-seamless-scroll :data="newsList2" :class-option="optionLeft" class="seamless-warp2">
                <ul class="item">
                    <li v-for="item in newsList2" :key="item" v-text="item"></li>
                </ul>
            </vue-seamless-scroll>
            <vue-seamless-scroll :data="newsList3" :class-option="optionLeft" class="seamless-warp2">
                <ul class="item">
                    <li v-for="item in newsList3" :key="item" v-text="item"></li>
                </ul>
            </vue-seamless-scroll>
            <vue-seamless-scroll :data="newsList4" :class-option="optionLeft" class="seamless-warp2">
                <ul class="item">
                    <li v-for="item in newsList4" :key="item" v-text="item"></li>
                </ul>
            </vue-seamless-scroll>
        </div>

        <img class="btn" src="../../../../assets/images/simustock/btn2.png" alt="" @click="appdown">
    </div>
</template>

<script>
export default {

    data(){
        return{
            t:'讨论区',
            newsList: [
                '爱股票里面高手云集' ,
                '不要慌，只是技术性调整' ,
                '冲冲冲' ,
                '今年这震荡行情下还能盈利的是真厉害',
            ],
            newsList2:[
                '实盘大佬们，买了医药和电力',
                '拿住了，大佬求带解套' ,
                '大A马上就要崛起了！' ,
                '跟上高手操作',
            ],
            newsList3:[
                '有涨停气质',
                '顶尖高手，值得好好学习' ,
                '这个比赛不错' ,
                '拿的好，让钱奔跑',
            ],
            newsList4:[
                '短线大赛开始啦',
                '看起来稳住了局面' ,
                '乘风破浪暂荆棘，一马平川拿涨停' ,
                '下次建仓跟你了！',
            ]
        }
    },
    computed: {
        optionLeft () {
            return {
                    direction: 2,
                    limitMoveNum: 3,
                    openTouch:false,
                    hoverStop:false,
                }
        }
    },
    methods: {
        appdown(){
            location.href = `https://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui`;
        }
    },
}

</script>
<style lang="scss" scoped>
    @import "~@/assets/sass/global.scss";
    .wrap{
        margin-top: rem(34px);
        background: #FFFFFF;
        border-radius: rem(20px);
        padding: rem(27px) rem(30px) rem(10px);
        text-align: center;

        >h1{
            font-size: rem(32px);
            text-align: center;
            font-weight: 600;
            color: #333333;
            line-height: rem(45px);
            margin-bottom: rem(33px);
        }


        .borad{
            //height: rem(404px);
            background: linear-gradient(180deg, #FFEBEB 0%, #FFF5DC 100%);
            border-radius: rem(30px);
            padding: rem(40px) 0 rem(10px);
        }

        .btn{
            width: rem(488px);
            margin: rem(40px) 0 0;
        }

    }

    .seamless-warp2 {
        margin: 0 auto;
        overflow: hidden;
        height: rem(58px);
        width: 100%;
        margin-bottom: rem(30px);
        ul.item {
            display: flex;
            width: max-content;
            li {
                margin-right: rem(20px);
                font-size: rem(26px);
                height: rem(58px);
                line-height: rem(58px);
                padding: 0 rem(20px);
                border-radius: rem(29px);
                background: #fff;
                flex-shrink: 0;
            }
        }
    }
</style>